import { render, staticRenderFns } from "./PsPatientBtnNewWeekend.vue?vue&type=template&id=a8844d26&scoped=true&"
import script from "./PsPatientBtnNewWeekend.vue?vue&type=script&lang=js&"
export * from "./PsPatientBtnNewWeekend.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientBtnNewWeekend.vue?vue&type=style&index=0&id=a8844d26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8844d26",
  null
  
)

export default component.exports